import { render, staticRenderFns } from "./MultiLanguageInputField.vue?vue&type=template&id=064cefc7"
import script from "./MultiLanguageInputField.vue?vue&type=script&lang=js"
export * from "./MultiLanguageInputField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports